import React from "react";
import { Create, LinearProgress, useTranslate } from "react-admin";

import WizardForm from "../../../components/forms/WizardForm";
import { useTerminalsContext } from "../../../contexts/TerminalsProvider";
import { DeviationWizardToolbar } from "../DeviationWizardToolbar";
import { Form1, Form2, Form3, Form4, Form5 } from "../forms";
import { useGetOrder, useOnSubmit } from "../requests_tools";

export const DeviationCreate = ({ orderId, ...props }) => {
	const translate = useTranslate();

	const { data: orderRecord, loaded } = useGetOrder(orderId);
	const { data: terminals, loading } = useTerminalsContext();

	const onSubmit = useOnSubmit(`deviations`, "POST", props.basePath, orderRecord);

	if (!loaded || loading) return <LinearProgress />;
	const terminalRecord = terminals[orderRecord.terminal_id];

	const mainTitle = translate(`resources.${props.resource}.name`);
	const title = `${translate("ra.action.create")} ${mainTitle}`;

	return (
		<Create {...props} title={title}>
			<WizardForm save={onSubmit} toolbarComponent={DeviationWizardToolbar}>
				<Form1 label="Category" terminalRecord={terminalRecord} />
				<Form2 label="Description" orderRecord={orderRecord} />
				<Form3 label="Details" orderRecord={orderRecord} />
				<Form4 label="Notification" orderRecord={orderRecord} terminalRecord={terminalRecord} />
				<Form5 label="Attachment" />
			</WizardForm>
		</Create>
	);
};
